<template>
  <div>
    <lerner-header :show-login-form="false" :pending="pending"></lerner-header>
    <page-header :title="selectedPage.title"></page-header>
    <div class="page-content col-12" v-html="selectedPage.content"></div>
    <ContactUsForm v-if="selectedPage.slug === 'contact-us'" v-on:submit="submitContactUsRequest" :pending="pending"></ContactUsForm>
    <RequestPricingForm v-if="selectedPage.slug === 'pricing'" v-on:submit="submitPricingRequest" :pending="pending"></RequestPricingForm>
    <app-footer :pages="pages"></app-footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import AppFooter from '@/component/AppFooter';
  import LernerHeader from '@/component/Header';
  import { PageExistsGuard } from '@/common/guards/pageExistsGuard';
  import RequestPricingForm from '@/views/RequestPricing/RequestPricingForm';
  import ContactUsForm from '@/views/ContactUs/ContactUsForm';
  import ContactService from '@/common/services/contact.service';
  import PageHeader from '@/component/PageHeader';
  import { CHANGE_DOC_TITLE } from '@/store/actions/app.actions';

  export default {
    name: 'page',

    data: () => {
      return {
        pending: false
      }
    },

    components: {
      PageHeader,
      LernerHeader,
      ContactUsForm,
      RequestPricingForm,
      AppFooter
    },

    beforeRouteUpdate (to, from, next) {
      return PageExistsGuard(to, from, next);
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: this.selectedPage.title, useBaseTitle: true})
    },

    computed: {
      ...mapGetters([
        'selectedPage',
        'pages'
      ])
    },

    watch: {
      selectedPage: function (newValue) {
        this.$store.dispatch(CHANGE_DOC_TITLE, {title: newValue.title, useBaseTitle: true})
      }
    },

    methods: {
      submitContactUsRequest(requestData) {
        this.pending = true;

        ContactService.contactUs(requestData)
          .then(() => this.$router.push({ name: 'contact-us-acknowledge' })
          .catch(() => {
            // TODO: Place error message here after creation
            this.$router.push({ name: 'error'});
          })
          .finally(() => this.pending = false));
      },
      submitPricingRequest(requestData) {
        this.pending = true;

        ContactService.requestPricing(requestData)
          .then(() => this.$router.push({ name: 'pricing-acknowledge' })
            .catch(() => {
              // TODO: Place error message here after creation
              this.$router.push({ name: 'error'});
            })
            .finally(() => this.pending = false));
      }
    }
  };
</script>

<style lang="scss">
  .page-content {
    h2 {
      @apply font-primary font-bold text-primary mb-6 leading-none;
      font-size: 20px;
    }

    a {
      @apply text-lerner-blue;
    }

    p, ul {
      @apply mb-6;
    }
  }
</style>
